"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
class EditBlockWrapper extends _react.default.Component {
  render() {
    // Wrapper Props
    // - children must always render
    const _this$props = this.props,
      block = _this$props.block,
      children = _this$props.children,
      editable = _this$props.editable;
    return /*#__PURE__*/_react.default.createElement("div", {
      onMouseEnter: () => {
        /*if (editable && !editing) onMouseOver(HOVER_MOUSE_KEY, block.id)*/
        if (editable) console.log("[Block ".concat(block.id, "] onMouseEnter"));
      },
      onMouseLeave: () => {
        /*if (editable && !editing) onMouseOut(HOVER_MOUSE_KEY)*/
        if (editable) console.log("[Block ".concat(block.id, "] onMouseLeavr"));
      },
      onKeyUp: evt => {
        // ESC keycode
        /*if (evt.keyCode === 27) {
          onCancelEdit(block)
        }*/
      }
    }, children);
  }
}
var _default = exports.default = EditBlockWrapper;